import { arbitrumSepolia, sepolia, arbitrum, base, mantle } from 'viem/chains';

import arbiSepoliaIcon from '../assets/arbiSepolia.svg';
import arbiIcon from '../assets/arbitrum.svg';
import sepoliaIcon from '../assets/sepolia.svg';
import baseIcon from '../assets/base.avif';
import mantleIcon from '../assets/mantle.svg';

// game supported network
export const chains = [arbitrum, base, mantle]; //arbitrumSepolia, sepolia, arbitrum, base
export const supportedChainIds = chains.map(c => c.id);
export const DEFAULT_CHAIN_ID = sepolia.id;
// for api chain map
export const GAME_NETWORK = {
  ARBITRUM_SEPOLIA: 'arbitrum_sepolia',
  SEPOLIA: 'ethereum_sepolia',
  ARBITRUM: 'arbitrum',
  BASE: 'base',
  MANTLE: 'mantle',
};

export const GAME_NETWORK_TO_CHAIN = {
  [GAME_NETWORK.ARBITRUM_SEPOLIA]: arbitrumSepolia,
  [GAME_NETWORK.SEPOLIA]: sepolia,
  [GAME_NETWORK.ARBITRUM]: arbitrum,
  [GAME_NETWORK.BASE]: base,
  [GAME_NETWORK.MANTLE]: mantle,
};
export const CHAIN_BE_MAP = {
  [arbitrumSepolia.id]: GAME_NETWORK.ARBITRUM_SEPOLIA,
  [sepolia.id]: GAME_NETWORK.SEPOLIA,
  [arbitrum.id]: GAME_NETWORK.ARBITRUM,
  [base.id]: GAME_NETWORK.BASE,
  [mantle.id]: GAME_NETWORK.MANTLE,
};

export const CHAIN_INFO = [
  // {
  //   ...arbitrumSepolia,
  //   id: arbitrumSepolia.id,
  //   name: arbitrumSepolia.name,
  //   iconUrl: arbiSepoliaIcon,
  // },
  // {
  //   ...sepolia,
  //   id: sepolia.id,
  //   name: sepolia.name,
  //   iconUrl: sepoliaIcon,
  // },
  {
    ...arbitrum,
    id: arbitrum.id,
    name: arbitrum.name,
    iconUrl: arbiIcon,
  },
  { ...base, id: base.id, name: base.name, iconUrl: baseIcon },
  {
    ...mantle,
    iconUrl: mantleIcon,
  },
];

export const SUPPORTED_CHAIN_ID = {
  ARBI_SEPOLIA: arbitrumSepolia.id,
  SEPOLIA: sepolia.id,
  ARBI: arbitrum.id,
  BASE: base.id,
  MANTLE: mantle.id,
};

export const EXPLORER = {
  [arbitrumSepolia.id]: `${arbitrumSepolia.blockExplorers.default.url}/`,
  [sepolia.id]: `${sepolia.blockExplorers.default.url}/`,
  [arbitrum.id]: `${arbitrum.blockExplorers.default.url}/`,
  [base.id]: `${base.blockExplorers.default.url}/`,
  [mantle.id]: `${mantle.blockExplorers.default.url}/`,
};

export const getChainIconFromName = (network: string) => {
  const chain_id = GAME_NETWORK_TO_CHAIN[network?.toLowerCase()]?.id;
  if (chain_id) {
    const chain = CHAIN_INFO.find(v => v.id === chain_id);
    return chain?.iconUrl;
  }
  return ``;
};
